/**
 * Helper functions for Focus Features navigation conditional logic
 */

/**
 * Check if Videos navigation item should be shown
 * Videos should appear only when videos are added in Media tab
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowVideos(movieData) {
	const trailers = movieData?.trailers || {};
	return Object.values(trailers).some(t => t?.url);
}

/**
 * Check if Tickets navigation item should be shown
 * Tickets should be shown only when ticketing date has been reached, page is active, and movie is not placeholder
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowTickets(movieData) {
	const isPlaceholder = movieData?.placeholder || movieData?.isPlaceholder;
	// Check status.theaters which validates both page active AND date reached
	const showtimesAvailable = movieData?.status?.theaters === 'preSale' || movieData?.status?.theaters === 'inTheaters';
	return !isPlaceholder && showtimesAvailable;
}

/**
 * Check if Watch at Home navigation item should be shown
 * Watch at Home should be shown only when HomeEnt date has been reached, page is active, and movie is not placeholder
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowWatchAtHome(movieData) {
	const isPlaceholder = movieData?.placeholder || movieData?.isPlaceholder;
	// Check status.homeEnt which validates both page active AND date reached
	return !isPlaceholder && movieData?.status?.homeEnt === 'homeEnt';
}

/**
 * Check if a Focus Features navigation link should be displayed
 * @param {Object} link - Navigation link object
 * @param {Object} movieData - Movie content data
 * @returns {boolean}
 */
export function shouldShowNavigationLink(link, movieData) {
	// Always filter out hidden links
	if (link.hidden) return false;

	// Apply conditional logic for default links
	switch (link.id) {
		case 'videos':
			return shouldShowVideos(movieData);
		case 'showtimes':
		case 'tickets':
			return shouldShowTickets(movieData);
		case 'homeEnt':
		case 'watchathome':
			return shouldShowWatchAtHome(movieData);
		case 'home':
			return true; // Home is always shown
		default:
			return true;
	}
}
